import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Mid Level Course Report ")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Mid Level Courses", -1)
const _hoisted_15 = { class: "row mt-3" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Enrollment Start", -1)
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Enrollment End", -1)
const _hoisted_20 = { class: "col-md-2 mt-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_22 = {
  class: "position-relative mt-7",
  style: {"overflow":"scroll"}
}
const _hoisted_23 = { class: "row w-100 mb-2" }
const _hoisted_24 = { class: "col-md-8" }
const _hoisted_25 = { class: "div pb-2 text-left" }
const _hoisted_26 = { class: "row mt-1 w-100 m-0" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = { class: "table table-borderless gy-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black  !important","text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "2"
    }, " Tranche "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "2"
    }, " Training Partner "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "2"
    }, " Course Type "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "2"
    }, " Course "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      colspan: "4",
      class: "border border-grey text-center"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      colspan: "3",
      class: "border border-grey text-center"
    }, " Assessment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      colspan: "3",
      class: "border border-grey text-center"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      colspan: "3",
      class: "border border-grey text-center"
    }, " Job Placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Target "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " % of Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " % of Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " % of Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " % of Female ")
  ])
], -1)
const _hoisted_40 = { style: {} }
const _hoisted_41 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_42 = { style: {"border":"1px solid  !important","text-align":"left"} }
const _hoisted_43 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_44 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_45 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_46 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_47 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_48 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_49 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_53 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_54 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_58 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_59 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_63 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_64 = { style: {"border":"1px solid  !important","text-align":"center"} }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"}
}, " Total ", -1)
const _hoisted_68 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_69 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_70 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_71 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_75 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_76 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_80 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_81 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { key: 1 }
const _hoisted_84 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_85 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_86 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                  options: _ctx.optionsTranche,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Tranche",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_select, {
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  class: "form-select-solid",
                  placeholder: "Select Training Partner",
                  modelValue: _ctx.entity_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_id) = $event)),
                  style: {"width":"100%"},
                  multiple: "",
                  filterable: "",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterEntity(_ctx.entity_id)))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (info) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: info.id,
                        label: '[' + info.entity_short_name + '] - ' + info.entity_name
                        ,
                        value: info.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_select, {
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  class: "form-select-solid",
                  placeholder: "Select Mid Level Course",
                  modelValue: _ctx.course_info_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.course_info_id) = $event)),
                  style: {"width":"100%"},
                  multiple: "",
                  filterable: "",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterCourse(_ctx.course_info_id)))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (data) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: data.id,
                        label: data.course_name,
                        value: data.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.course_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_el_form_item, {
                  prop: "start_date",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.start_date,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.start_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      style: {"width":"100%"},
                      type: "date",
                      name: "satrt"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_el_form_item, {
                  prop: "end_date",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.end_date,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.end_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      style: {"width":"100%"},
                      type: "date",
                      name: "satrt"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.midLevelCourseReport())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_21
                ])
              ])
            ]),
            (_ctx.showCourseNotice == true)
              ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("h4", null, "Mid Level Course Report (Total: " + _toDisplayString(_ctx.courseSummaryReport.length) + ")", 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                          title: "Download Xlse",
                          "data-v-54b12dc8": "",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportTrainee()))
                        }, _hoisted_31),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Download PDF",
                          "data-v-54b12dc8": "",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadPdf()))
                        }, _hoisted_33),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Print",
                          "data-v-54b12dc8": "",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.printPdf()))
                        }, _hoisted_35)
                      ]),
                      _hoisted_36,
                      _hoisted_37
                    ]),
                    _createElementVNode("table", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("tbody", _hoisted_40, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.courseSummaryReport, (info, key) => {
                          return (_openBlock(), _createElementBlock("tr", { key: key }, [
                            _createElementVNode("td", _hoisted_41, _toDisplayString(key + 1), 1),
                            _createElementVNode("td", _hoisted_42, _toDisplayString(info?.tranche_data?.label), 1),
                            _createElementVNode("td", _hoisted_43, _toDisplayString(info?.entities?.entity_short_name), 1),
                            _createElementVNode("td", _hoisted_44, _toDisplayString(info?.course_type_info?.course_parent_type?.type_name), 1),
                            _createElementVNode("td", _hoisted_45, _toDisplayString(info?.course_name), 1),
                            _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.numberWithCommas(info?.total_target_trainee)), 1),
                            _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.numberWithCommas(info?.enrollment)), 1),
                            _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.numberWithCommas(info?.femaleEnrollment)), 1),
                            _createElementVNode("td", _hoisted_49, [
                              (info?.femaleEnrollment == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_50, "0.00"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(((info?.femaleEnrollment / info?.enrollment) * 100).toFixed(2)), 1))
                            ]),
                            _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.numberWithCommas(info?.assessed)), 1),
                            _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.numberWithCommas(info?.female_assessed)), 1),
                            _createElementVNode("td", _hoisted_54, [
                              (info?.female_assessed == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_55, "0.00"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(((info?.female_assessed / info?.assessed) * 100).toFixed(2)), 1))
                            ]),
                            _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.numberWithCommas(info?.certification)), 1),
                            _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.numberWithCommas(info?.female_certification)), 1),
                            _createElementVNode("td", _hoisted_59, [
                              (info?.female_certification == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_60, "0.00"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(((info?.female_certification / info?.certification) * 100).toFixed(2)), 1))
                            ]),
                            _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.numberWithCommas(info?.job_placement)), 1),
                            _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.numberWithCommas(info?.female_job_placement)), 1),
                            _createElementVNode("td", _hoisted_64, [
                              (info?.female_job_placement == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_65, "0.00"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(((info?.female_job_placement / info?.job_placement) * 100).toFixed(2)), 1))
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("tr", null, [
                          _hoisted_67,
                          _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.numberWithCommas(this.Totaltarget)), 1),
                          _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.numberWithCommas(this.Totalenrollment)), 1),
                          _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.numberWithCommas(this.Totalenrollment_female)), 1),
                          _createElementVNode("td", _hoisted_71, [
                            (this.Totalenrollment_female == 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_72, "0.00"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(((this.Totalenrollment_female / this.Totalenrollment) * 100).toFixed(2)), 1))
                          ]),
                          _createElementVNode("td", _hoisted_74, _toDisplayString(_ctx.numberWithCommas(this.Totalassessed)), 1),
                          _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.numberWithCommas(this.Totalassessed_female)), 1),
                          _createElementVNode("td", _hoisted_76, [
                            (this.Totalassessed_female == 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_77, "0.00"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(((this.Totalassessed_female / this.Totalassessed) * 100).toFixed(2)), 1))
                          ]),
                          _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.numberWithCommas(this.Totalcertification)), 1),
                          _createElementVNode("td", _hoisted_80, _toDisplayString(_ctx.numberWithCommas(this.Totalcertification_female)), 1),
                          _createElementVNode("td", _hoisted_81, [
                            (this.Totalcertification_female == 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_82, "0.00"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(((this.Totalcertification_female / this.Totalcertification) * 100).toFixed(2)), 1))
                          ]),
                          _createElementVNode("td", _hoisted_84, _toDisplayString(_ctx.numberWithCommas(this.Totaljobplacement)), 1),
                          _createElementVNode("td", _hoisted_85, _toDisplayString(_ctx.numberWithCommas(this.Totaljobplacement_female)), 1),
                          _createElementVNode("td", _hoisted_86, [
                            (this.Totaljobplacement_female == 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_87, "0.00"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(((this.Totaljobplacement_female / this.Totaljobplacement) * 100).toFixed(2)), 1))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}